export default "__VITE_ASSET__f2832a33__"